import React, { useEffect, useState } from "react";
import { PageContextUtils, StoreUtils } from "../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import { UserContextSelectors } from "../../../../redux/selectors";
import { LocalizationMessages } from "../../../../localization/messages";
import { FormattedMessage, useIntl } from "react-intl";
import { TrackingUtils } from "../../../../utils";
import {
  MyAccountAreaFooterWrapper,
  AppVersion,
  LogoutButton,
  Separator
} from "./myAccountAreaFooterWrapper";
import { AccountActionCreators } from "../../../../redux/action-creators";
import { TrackingInfo } from "../../../tracking/TrackingInfoMyAccountArea";
import { useLogout } from "../../../../hooks/useLogout";

const MyAccountAreaFooter = () => {
  const isNative = useSelector(UserContextSelectors.isNative);
  const { clientVersion } = PageContextUtils.getDeviceData();
  const { clientLangIso3 } = PageContextUtils.getLocalizationData();
  const { versionNumber } = PageContextUtils.getReleaseData();
  const nativeVersion = StoreUtils.getNativeDataStoreItem("AppVersion");
  const [appVersion, setAppVersion] = useState("");

  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const { showLogoutPopup } = useLogout();

  useEffect(() => {
    let appVerBuilder = `${formatMessage(
      LocalizationMessages.AppVersion
    )} ${clientVersion}-${clientLangIso3?.toUpperCase()}-${versionNumber}`;
    if (isNative) appVerBuilder += `-${nativeVersion}`;
    setAppVersion(appVerBuilder);
  }, [
    clientVersion,
    formatMessage,
    isNative,
    clientLangIso3,
    nativeVersion,
    versionNumber
  ]);

  const logout = async () => {
    dispatch(AccountActionCreators.toggleAccountDrawer());

    TrackingUtils.sendAnalytics({
      ...TrackingInfo,
      dataLabel: "Logout"
    });

    showLogoutPopup();
  };

  return (
    <MyAccountAreaFooterWrapper>
      <AppVersion data-testid="uc-my-account-area-footer-app-version">
        {appVersion}
      </AppVersion>
      <Separator />
      <LogoutButton
        onClick={logout}
        data-testid="uc-my-account-area-footer-logout"
      >
        <FormattedMessage {...LocalizationMessages.logoutText} />
      </LogoutButton>
    </MyAccountAreaFooterWrapper>
  );
};

export default React.memo(MyAccountAreaFooter);
